export default "__VITE_ASSET__CF9iiH1M__"